import { Component, OnInit } from '@angular/core';
import { ModalExtended} from 'ngx-dynamic-modal';
import { FormControl,FormGroup, NgForm, Validators} from '@angular/forms';
import { ElementCacheService} from '../../services/element-cache.service';
import { FileUploadService} from '../../services/file-upload.service';
import { Ng2FileInputService} from 'ng2-file-input';
import {AuthService} from '../../../../../core/service/auth.service';
import { AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-cache-delete-from-file-modal',
  templateUrl: './cache-delete-from-file-modal.component.html',
  styleUrls: ['./cache-delete-from-file-modal.component.scss']
})
export class CacheDeleteFromFileModalComponent extends ModalExtended implements OnInit {

    enabled: boolean;
    formSearch: FormGroup;
    fileToUpload: File  = null;
    fileUploadSub: any;
    serverResponse: Object = {};
    errors: Object = {};
    key: Object = {};

    enclosureTypes=[
        {value: "DOUBLE_QUOTE", label: 'Double Quote '+ '( \" )'},
        {value: "SIMPLE_QUOTE", label: 'Single Quote '+'( \' ) ' },
        {value: "EMPTY", label: 'Empty'}
    ];

    delimiterTypes=[
        {value: ";", label: 'Dot and comma' + ' ( ; )' },
        {value: ",", label: 'Comma' + ' ( , )' },
        {value: "TAB", label: 'Tab' + ' ( )' },
        {value: "|", label:'Pipe' + ' ( | )' },
        {value: "~|~", label: 'Special type'+ ' ( ~|~ )' }
    ];

    constructor(private  elementCacheService: ElementCacheService,
                private  uploader: FileUploadService,
                private ng2Inputservice: Ng2FileInputService,
                private auth: AuthService,
                private  alerta:AlertaService) {
        super();
        this.formSearch = new FormGroup({
            'enclosure': new FormControl(),
            'delimiter': new FormControl(),
            'type':new FormControl(null,Validators.required),
            'lang': new FormControl(null,Validators.required),
            'portal':new FormControl(this.auth.getPortalSelected().portal),
            'service': new FormControl(null,Validators.required)
            }
            )
    }

  ngOnInit() {}


  deleteFromFile(event: any, form: NgForm, search: FormGroup) {
      this.errors = {};
      this.serverResponse = {};
      event.preventDefault();
      if (form.submitted && form.valid && this.fileToUpload != null) {
          this.key = {
              'type': search.value.type,
              'portal': this.auth.getPortalSelected().portal,
              'lang': search.value.lang,
              'service': search.value.service
          };
          this.enabled = true;
          let submittedData = search.value;
          let formData = this.uploader.fileUpload(this.fileToUpload, submittedData);
          this.fileUploadSub = this.elementCacheService.removeElementCacheEntriesFromFile(formData, this.key['type'])
              .subscribe(result => {
                  if (result.hasOwnProperty('errors')) {
                      this.errors = result['errors'];
                      return;
                  }
                  this.serverResponse = result;
              }, error => {
                  console.log(error);
                  this.enabled = false;
              }, () => {
                  this.enabled = false;
                  this.ng2Inputservice.reset('file');
                  this.fileToUpload = null;
              });
          form.resetForm({});
      }

  }

  selectFile(event){
        this.fileToUpload = event.file;

    }

    confirmDelete(confirm){
        if(!confirm){
            this.serverResponse={};
            this.alerta.addAlert('warning','Cancelled!!')
            return false;
        }
        this.enabled=true;
        this.fileUploadSub = this.elementCacheService.removeElementCacheEntriesFromFile({path:this.serverResponse['path'],key:this.key},this.key['type'])
            .subscribe( result => {
                this.serverResponse={};
                console.log('Los numeros borrados son: -->',result['data']);
                }, error => {
                console.log(error);
                this.enabled=false;
               this.alerta.addAlert('error','Something went Wrong!!')
            }, () => {
                this.alerta.addAlert('success','All Numbers Deleted Succesfully!!')
                this.enabled=false;
                this.key={};
            })
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/modals/cache-delete-from-file-modal/cache-delete-from-file-modal.component.ts